import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addmobileLoginParams from "./components/addmobileLoginParams";
import parameterPopup from "@/components/parameterPopup/parameterPopup";
export default {
  name: "mobileLoginParameters",
  mixins: [loadMoreList, commonData],
  components: {
    addmobileLoginParams: addmobileLoginParams,
    parameterPopup: parameterPopup
  },
  data: function data() {
    return {
      pagingReqFn: "phoneOneKeyLoginList",
      delIds: [],
      paramsData: {}
    };
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getcommonData(['appListAllData']);

              _this.getList();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    reset: function reset(row, index, type) {
      var _this2 = this;

      this.$confirm('请确认当前操作?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$api.GatewaySdkresetJwt({
          id: row.id
        }).then(function (res) {
          if (res.status == 200) {
            _this2.$message.success('重置成功');

            _this2.tableData[index].jwt_secret = res.data;
          }
        });
      });
    },
    del: function del(row) {
      var _this3 = this;

      console.log(row);
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'phoneOneKeyLoginDel',
        data: {
          id: row[0].id,
          appid: row[0].appid
        }
      }).then(function () {
        _this3.getList(_this3.paramsData.page);
      });
    }
  }
};